module.exports = __webpack_public_path__ + "static/media/login-background.6b774ad5.jpg";